<template>
  <swiper
    :pagination="{
      dynamicBullets: true,
    }"
    :autoplay="{
      delay: 2500,
      disableOnInteraction: false,
    }"
    :navigation="true"
    :modules="modules"
    class="myImageSlider"
    id="container"
  >
    <swiper-slide v-for="(image, index) in imagesList" :key="index">
      <img :src="image" alt="" />
    </swiper-slide>
  </swiper>

  <div class="slider-score-div">
    <div class="score">
      <p>{{ score || "ثبت نشده" }}</p>
      <p>({{ scoreReference || "0" }})</p>
    </div>
    <p class="suggestion" v-if="suggestion">پیشنهادی</p>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper";
export default {
  name: "ImageSlider",
  props: {
    productId: Number,
    imagesList: Object,
    score: Number,
    scoreReference: Number,
    suggestion: Boolean,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/ImageSlider/ImageSlider.css);
</style>